import { useTranslation } from 'react-i18next';

import { AppearanceSettings } from '@/components/settings/AppearanceSettings';

/**
 * Appearance panel — theme presets + custom colours (AppearanceSettings) and
 * the compact-banner layout toggle. Banner selection lives in the Profilo
 * "Banner & Avatar" section, not here. Reached from the Profilo "Settings" block.
 */
export function Appearance() {
  // ⚠️ Il padding in basso e' `max(1.5rem, var(--ingombro-flottante, 0px))`: col bottone dei minigiochi montato l'ultimo elemento (l'interruttore della
  // v3) scorre sopra di lui invece di restargli sotto; senza il bottone la variabile non c'e' e il padding e' 1.5rem, come prima.
  const { t } = useTranslation('general');

  return (
    <div className="flex flex-col gap-6 px-4 pb-[max(1.5rem,var(--ingombro-flottante,0px))] pt-5">
      {/* I-318, ADR-0190 §1: titolo di sezione fuori dalla vista, `sr-only`; la chiave resta in uso. */}
      <header className="sr-only">
        <h1>
          {t('appearance', { defaultValue: 'Appearance' })}
        </h1>
      </header>

      {/* Theme presets + custom colours + reset */}
      <AppearanceSettings />

      {/* L'interruttore "banner compatto" non c'e' piu': la compressione e' una
          conseguenza dello scroll, non una preferenza. Lasciarlo qui avrebbe
          creato una contraddizione — un utente che lo spegne e vede il banner
          comprimersi comunque appena scorre. */}
    </div>
  );
}
